import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import getLocation from '../../../assets/countries.json';
import { useTranslation } from 'react-i18next';

// Components
import TherapyGeneralForm from 'src/components/forms/admin/therapy/TherapyGeneralForm';
import ConfirmationPopup from 'src/ui/popups/ConfirmationPopup';

// Interfaces
import { TherapistFormikFormProps } from 'src/interfaces/ui/formInterface';

// Redux
import { setEditTherapistDetailView } from 'src/redux/slices/therapy.slice';

// Services
import { getTherapistDetailUseCase } from 'src/services/therapy/useCases';
import { updateTherapyUseCase } from 'src/services/therapy/useCases';

const EditTherapy = () => {
  const params = useParams<{ therapistId: string }>();
  const role = useAppSelector((state) => state.auth.role);
  const TherapistDetail = useAppSelector((state) => state.therapy.TherapistDetail);
  const editTherapistDetailView = useAppSelector((state) => state.therapy.editTherapistDetailView);
  const [editInfo, setEditInfo] = useState({});
  const [showEditCoach, setShowEditCoach] = useState<boolean>(false);
  const { t } = useTranslation(['addEditTherapyForm']);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = getLocation?.states;
  localStorage.setItem('current-Therapist', JSON.stringify(params.therapistId));
  let stateEditing: any = '';

  const currentRole = useAppSelector((state) => state.auth.role);
  const idForDispatch = currentRole === 'admin' ? params.therapistId : TherapistDetail.id;
  localStorage.setItem('current-Therapist', JSON.stringify(idForDispatch));

  const findState = (stateName: any) => {
    const state = location.find((state: any) => state.state_code === stateName);
    stateEditing = state;
    return state?.id;
  };

  const findCity = (cityName: any) => {
    if (stateEditing) {
      const city = stateEditing.cities.find((city: any) => city.name === cityName);
      return city?.id;
    }
  };

  const handleSuccess = async (values: TherapistFormikFormProps) => {
    const editLocation = {
      stateId: values.location?.stateId,
      cityId: values.location?.cityId,
    };
    const editValues: any = {};
    if (TherapistDetail.fullName !== values.fullName) editValues.fullName = values.fullName;
    if (TherapistDetail.email !== values.email) editValues.email = values.email;
    if (TherapistDetail.phone !== values.phone) editValues.phone = values.phone;
    if (values.location?.stateId) {
      if (findState(TherapistDetail.state) !== Number(values.location?.stateId))
        editValues.location = editLocation;
      if (findCity(TherapistDetail.city) !== Number(values.location?.cityId))
        editValues.location = editLocation;
    }
    if (TherapistDetail.description !== values.description)
      editValues.description = values.description;
    if (TherapistDetail.gender !== values.gender) editValues.gender = values.gender;
    if (TherapistDetail.shortDescription !== values.shortDescription)
      editValues.shortDescription = values.shortDescription;
    editValues.preferredLocale = values.preferredLocale;
    const updateTherapyGeneralInfo = Object.assign({}, editValues);
    if (
      updateTherapyGeneralInfo.fullName ||
      updateTherapyGeneralInfo.email ||
      updateTherapyGeneralInfo.phone ||
      updateTherapyGeneralInfo.description ||
      updateTherapyGeneralInfo.location ||
      updateTherapyGeneralInfo.shortDescription ||
      updateTherapyGeneralInfo.preferredLocale
    ) {
      setEditInfo(updateTherapyGeneralInfo);
      setShowEditCoach(true);
    } else {
      dispatch(setEditTherapistDetailView('edit-additional-info'));
    }
  };

  const handleEditCoach = () => {
    dispatch(
      updateTherapyUseCase({
        therapistId: String(idForDispatch),
        updatedTherapist: editInfo,
      }),
    );
  };

  useEffect(() => {
    if (editTherapistDetailView === 'edit-additional-info') {
      if (role === 'admin') {
        navigate(`/admin/therapy/${idForDispatch}/edit-therapy/additional-info`);
      } else navigate(`additional-info`);
    }
  }, [editTherapistDetailView, navigate, idForDispatch, role]);

  useEffect(() => {
    if (idForDispatch && currentRole === 'admin') {
      dispatch(getTherapistDetailUseCase(String(idForDispatch)));
    }
  }, [currentRole, dispatch, idForDispatch]);

  return (
    <>
      <TherapyGeneralForm onSuccess={handleSuccess} data={TherapistDetail} isEditing={true} />
      <ConfirmationPopup
        isVisible={showEditCoach}
        title={t('editAlert.title')}
        subtitle={t('editAlert.subtitle')}
        submitBtn={t('editAlert.confirm')}
        handleSubmit={handleEditCoach}
        onClose={() => setShowEditCoach(false)}
      />
    </>
  );
};

export default EditTherapy;
